import { Routes, Route } from 'react-router-dom'
import { InvoicePage } from './pages/InvoicePage'
import { NotFoundPage } from './pages/NotFoundPage'

function App() {
  return (
    <div className="min-h-screen bg-background">
      <Routes>
        <Route path="/i/:paymentToken" element={<InvoicePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  )
}

export default App
